export const PageTitle = ({
  title,
  className = '',
  id,
}: {
  title: string;
  className?: string;
  id?: string;
}) => {
  return (
    <h3 id={id} className={`text-2xl font-semibold ${className}`}>
      {title}
    </h3>
  );
};
